import styled from 'styled-components';

const LayoutContentStyle = styled.div`
   
`;

export default LayoutContentStyle;
